/* tslint:disable */
// import { Injectable, Inject, Optional } from '@angular/core';
// import { HttpClient, HttpResponse } from '@angular/common/http';
// import { SDKModels } from './SDKModels';
// import { BaseLoopBackApi } from '../core/base.service';
// import { LoopBackConfig } from '../../lb.config';
// import { LoopBackAuth } from '../core/auth.service';
// import { LoopBackFilter,  } from '../../models/BaseModels';
// import { ErrorHandler } from '../core/error.service';
// import { Observable, Subject } from 'rxjs';
// import { map } from 'rxjs/operators';
// import { SuspectAttendance } from '../../models/SuspectAttendance';
// import { SocketConnection } from '../../sockets/socket.connections';

import { Injectable, Inject, Optional } from '@angular/core';
import { SDKModels } from './SDKModels';
import { BaseLoopBackApi } from '../core/base.service';
import { LoopBackConfig } from '../../lb.config';
import { LoopBackAuth } from '../core/auth.service';
import { ErrorHandler } from '../core/error.service';
import { Observable } from 'rxjs';
import { JSONSearchParams } from '../core/search.params';
import { Http } from '@angular/http';
import { SocketConnection } from '../../sockets/socket.connections';

/**
 * Api services for the `SuspectAttendance` model.
 */
@Injectable()
export class SuspectAttendanceApi extends BaseLoopBackApi {

  // constructor(
  //   @Inject(HttpClient) protected http: HttpClient,
  //   @Inject(SocketConnection) protected connection: SocketConnection,
  //   @Inject(SDKModels) protected models: SDKModels,
  //   @Inject(LoopBackAuth) protected auth: LoopBackAuth,
  //   @Optional() @Inject(ErrorHandler) protected errorHandler: ErrorHandler
  // ) {
  //   super(http,  connection,  models, auth, errorHandler);
  // }

  constructor(
    @Inject(Http) protected http: Http,
    @Inject(SocketConnection) protected connection: SocketConnection,
    @Inject(SDKModels) protected models: SDKModels,
    @Inject(LoopBackAuth) protected auth: LoopBackAuth,
    @Inject(JSONSearchParams) protected searchParams: JSONSearchParams,
    @Optional() @Inject(ErrorHandler) protected errorHandler: ErrorHandler
  ) {
    super(http,  connection,  models, auth, searchParams, errorHandler);
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {Object} params 
   *
   * @param {} cont 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `SuspectAttendance` object.)
   * </em>
   */
  public excel(params: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/SuspectAttendances/excel";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof params !== 'undefined' && params !== null) _urlParams.params = params;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {Object} params 
   *
   * @param {} cont 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `SuspectAttendance` object.)
   * </em>
   */
  public pdfmake(params: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/SuspectAttendances/pdfmake";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof params !== 'undefined' && params !== null) _urlParams.params = params;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {Object} params 
   *
   * @param {} cont 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `SuspectAttendance` object.)
   * </em>
   */
  public previewReport(params: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/SuspectAttendances/previewReport";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof params !== 'undefined' && params !== null) _urlParams.params = params;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * The name of the model represented by this $resource,
   * i.e. `SuspectAttendance`.
   */
  public getModelName() {
    return "SuspectAttendance";
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/services/custom/SuspectAttendance.ts